import axios from "axios";

export const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
    baseURL: `${API_URL}/api`,
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("strake_token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    (resp) => resp,
    (err) => {
        // If admin token expired while on /admin, clear and redirect
        if (err?.response?.status === 401 && window.location.pathname.startsWith("/admin")) {
            localStorage.removeItem("strake_token");
            if (window.location.pathname !== "/admin/login") {
                window.location.href = "/admin/login";
            }
        }
        return Promise.reject(err);
    }
);

// Public
export const fetchContent = () => api.get("/content").then((r) => r.data);
export const fetchCategories = () => api.get("/categories").then((r) => r.data);
export const fetchMenuItems = () => api.get("/menu-items").then((r) => r.data);

// Auth
export const login = (email, password) =>
    api.post("/auth/login", { email, password }).then((r) => r.data);
export const me = () => api.get("/auth/me").then((r) => r.data);
export const changePassword = (current_password, new_password) =>
    api.post("/auth/change-password", { current_password, new_password }).then((r) => r.data);

// Admin: categories
export const createCategory = (body) => api.post("/admin/categories", body).then((r) => r.data);
export const updateCategory = (id, body) => api.put(`/admin/categories/${id}`, body).then((r) => r.data);
export const deleteCategory = (id) => api.delete(`/admin/categories/${id}`).then((r) => r.data);
export const reorderCategories = (ids) => api.put("/admin/categories/reorder", { ids }).then((r) => r.data);

// Admin: menu items
export const createMenuItem = (body) => api.post("/admin/menu-items", body).then((r) => r.data);
export const updateMenuItem = (id, body) => api.put(`/admin/menu-items/${id}`, body).then((r) => r.data);
export const deleteMenuItem = (id) => api.delete(`/admin/menu-items/${id}`).then((r) => r.data);
export const reorderMenuItems = (ids) => api.put("/admin/menu-items/reorder", { ids }).then((r) => r.data);

// Admin: content
export const updateContent = (data) => api.put("/admin/content", { data }).then((r) => r.data);

// Admin: image upload
export const uploadImage = (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return api
        .post("/admin/images", fd, { headers: { "Content-Type": "multipart/form-data" } })
        .then((r) => {
            // Convert relative API url to absolute
            return { ...r.data, url: `${API_URL}${r.data.url}` };
        });
};

export const errMsg = (e) => {
    const d = e?.response?.data?.detail;
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((x) => (x?.msg ? x.msg : JSON.stringify(x))).join(" ");
    return e?.message || "Something went wrong";
};

export default api;
